import { gql } from "generated-graphql";

gql(`
  fragment ProcessedManifestRow on ProcessedManifest {
    id
    epaId
    manifestTrackingNumber
    vendor
    shippedDate
    wasteLineCount
    unresolvedDiscrepancyCount
    pendingDiscrepancyCount
    vendor
    isEManifest
    isCertified
    eManifestCertifiedDate
    eManifestCreatedDate
    eManifestDaysInTransit
    receivedDate
    isRegulatedEManifest
    desFacilityName
    facility {
      id
      name
      streetAddress1
      city
      state
      zip
    }
    vendorManifest {
      id
      manifestTrackingNumber
      shippedDate
      vendorSource
      desFacilityName

      originalManifestTrackingNumber
      originalShippedDate
      originalVendorSource
      originalDesFacilityName

      manuallyEdited
    }
    wasteTransporters {
      transporterLineNumber
      transporterName
      transporterId
      daysInPossession
      vendorAddressLine1
      vendorAddressLine2
      vendorCity
      vendorState
      vendorZip
    }
    sourceDocument {
      id
      title
      documentType
      fileExtension
      storageLink
      sizeMegabytes
      createdAt
    }
  }
`);

export const PROCESSED_MANIFEST_DOCUMENTS_QUERY = gql(`
  query ProcessedManifestDocuments($search: String) {
    processedManifests(search: $search, page: 0, pageSize: 1) {
      items {
        id
        documents {
          id
          document {
            id
            title
            fileExtension
            documentType
            storageLink
            createdAt
          }
        }
      }
    }
  }
`);

export const PROCESSED_MANIFESTS_QUERY = gql(`
  query ProcessedManifests($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    processedManifests(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...ProcessedManifestRow
      }
      count
    }
  }
`);

export const DELETE_VENDOR_MANIFEST_AND_LINE_ITEMS_MUTATION = gql(`
  mutation DeleteVendorManifestAndLineItems($id: ID!) {
    deleteVendorManifestAndLineItems(id: $id)
  }
`);

export const REVERT_VENDOR_MANIFEST_AND_LINE_ITEMS_MUTATION = gql(`
  mutation RevertVendorManifestAndLineItems($id: ID!) {
    revertVendorManifestAndLineItems(id: $id) {
      originalProcessedManifest {
        id
        manifestTrackingNumber
        shippedDate
        vendor
        desFacilityName
        vendorManifest {
          manifestTrackingNumber
          shippedDate
          vendorSource
          desFacilityName
          manuallyEdited
        }
      }
      newProcessedManifest {
        id
        manifestTrackingNumber
        shippedDate
        vendor
        desFacilityName
        vendorManifest {
          manifestTrackingNumber
          shippedDate
          vendorSource
          desFacilityName
          manuallyEdited
        }
      }
    }
  }
`);

export const ATTACH_DOCUMENT_TO_MANIFEST = gql(`
  mutation AttachDocumentToManifest($processedManifestId: ID!, $documentId: ID!) {
    attachDocumentToManifest(processedManifestId: $processedManifestId, documentId: $documentId) {
      id
      document {
        id
        title
        fileExtension
        documentType
        storageLink
        createdAt
      }
    }
  }
`);

export const DETACH_DOCUMENT_FROM_MANIFEST = gql(`
  mutation DetachDocumentFromManifest($processedManifestDocumentId: ID!) {
    detachDocumentFromManifest(processedManifestDocumentId: $processedManifestDocumentId)
  }
`);
